export default __webpack_public_path__ + "static/media/Belt of the Assailant.f66e1448.jpg";